import React, { useContext, useEffect, useState } from "react";
import { Layout, Button, Avatar, Dropdown, Menu, Space } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import {
  UserOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  AppstoreOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { LanguageContext } from "../LanguageContext";

const { Header, Content, Footer } = Layout;

const AppLayout = ({ children }) => {
  const { language, setLanguage, translations } = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [userName, setUserName] = useState("Kullanıcı");
  const [activeButton, setActiveButton] = useState("");

  useEffect(() => {
    const fetchUserName = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) return;
      try {
        const response = await fetch(
          `https://json-configrator-api.root.myoctoopidev.com/User/GetById/${userId}`
        );
        const data = await response.json();
        setUserName(data?.data?.name || "Kullanıcı");
      } catch (error) {
        console.error("Kullanıcı bilgisi alınamadı:", error);
      }
    };
    fetchUserName();
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/userdashboard")) setActiveButton("konfig");
    else if (path.includes("/usersupport")) setActiveButton("support");
    else setActiveButton("");
  }, [location.pathname]);

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" icon={<UserOutlined />} onClick={() => navigate("/useraccount")}>
        {translations[language].profile}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        danger
        onClick={() => {
          localStorage.removeItem("userId");
          localStorage.removeItem("authToken");
          navigate("/login");
        }}
      >
        {translations[language].exit}
      </Menu.Item>
    </Menu>
  );

  const navBtnStyle = (key) => ({
    height: 36,
    borderRadius: 6,
    fontWeight: 500,
    fontSize: 14,
    border: 'none',
    background: activeButton === key
      ? 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'
      : 'rgba(255,255,255,0.1)',
    color: '#fff',
    boxShadow: activeButton === key ? '0 4px 12px rgba(24,144,255,0.35)' : 'none',
  });

  return (
    <Layout style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Header
        style={{
          background: "#001529",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 30px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {/* Sol: Logo + Başlık */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            cursor: "pointer",
          }}
          onClick={() => navigate("/userdashboard")}
        >
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 10px rgba(24,144,255,0.4)",
            }}
          >
            <SettingOutlined style={{ color: "#fff", fontSize: 16 }} />
          </div>
          <span style={{ color: "#fff", fontSize: 17, fontWeight: 600 }}>
            {translations[language].layoutTitle}
          </span>
        </div>

        {/* Sağ: Navigasyon + Dil + Avatar */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Button
            icon={<QuestionCircleOutlined />}
            style={navBtnStyle("support")}
            onClick={() => { setActiveButton("support"); navigate("/usersupport"); }}
          >
            {translations[language].howUsing}
          </Button>

          <Button
            icon={<AppstoreOutlined />}
            style={navBtnStyle("konfig")}
            onClick={() => { setActiveButton("konfig"); navigate("/userdashboard"); }}
          >
            {translations[language].konfig}
          </Button>

          {/* Dil seçici */}
          <select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            style={{
              background: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.25)",
              borderRadius: 6,
              color: "#fff",
              padding: "6px 10px",
              fontSize: 14,
              cursor: "pointer",
              outline: "none",
            }}
          >
            <option value="tr" style={{ color: "#000", background: "#fff" }}>Türkçe</option>
            <option value="en" style={{ color: "#000", background: "#fff" }}>English</option>
            <option value="de" style={{ color: "#000", background: "#fff" }}>Deutsch</option>
          </select>

          {/* Kullanıcı avatar */}
          <Dropdown overlay={userMenu} placement="bottomRight">
            <Space style={{ cursor: "pointer" }}>
              <Avatar
                style={{
                  background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
                  boxShadow: "0 2px 8px rgba(24,144,255,0.4)",
                  fontWeight: 600,
                }}
              >
                {userName?.charAt(0).toUpperCase()}
              </Avatar>
              <span style={{ color: "#fff", fontWeight: 500, fontSize: 14 }}>{userName}</span>
            </Space>
          </Dropdown>
        </div>
      </Header>

      <Content style={{ padding: "20px", flex: 1, overflow: "auto", background: "#f0f2f5" }}>
        {children}
      </Content>

      <Footer
        style={{
          textAlign: "center",
          background: "#fff",
          borderTop: "1px solid #f0f0f0",
          padding: "12px",
          fontSize: 13,
          color: "#8c8c8c",
        }}
      >
        © 2026{" "}
        <a href="http://octoopi.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#1890ff" }}>
          Octoopi
        </a>{" "}
        &amp; by{" "}
        <a href="https://mertech.com.tr/" target="_blank" rel="noopener noreferrer" style={{ color: "#1890ff" }}>
          Mertech Electronics
        </a>
      </Footer>
    </Layout>
  );
};

export default AppLayout;
